import React, {useCallback, useMemo} from 'react'
import {RefundAmount as Refund} from 'app/features/orders/componentsv1/edit'
import {
  selectRefund,
  selectViewOrder,
  selectViewOrderPaymentMethod,
  setOrderRefundPrice,
  selectIsValidatingDiscount,
  setOrderItems,
  resetDeleteItems,
} from 'app/features/orders/redux/order/refundSlice'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {RefundOrder} from 'app/features/orders/models/OrderRefundState'
import capitalize from 'lodash/capitalize'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {Alert} from 'react-bootstrap'

export const RefundAmount: React.FC = () => {
  const dispatch = useDispatch()
  const refund = useSelector<RootState, RefundOrder>(selectRefund)
  const paymentMethod = useSelector<RootState, any>(selectViewOrderPaymentMethod)
  const viewOrder = useSelector<RootState, ViewOrder>(selectViewOrder)
  const isValidating = useSelector<RootState, boolean>(selectIsValidatingDiscount)

  const handleAmountChange = useCallback(
    (amount: number | any) => {
      dispatch(setOrderRefundPrice(amount))
      dispatch(resetDeleteItems())
      dispatch(setOrderItems(refund.orderItems))
    },
    [dispatch, refund.orderItems]
  )

  const pm = useMemo(() => {
    if (paymentMethod && paymentMethod.card) {
      const {brand, last4} = paymentMethod.card
      return {title: `To ${capitalize(brand)} Ending ${last4}`, brand}
    }
    return {title: 'To Your Payment Method', brand: null}
  }, [paymentMethod])

  if (viewOrder.totalPrice <= 0) {
    return null
  }

  return (
    <>
      <Refund
        {...pm}
        onAmountChange={handleAmountChange}
        refundPrice={refund.orderRefundPrice}
        maxRefundPrice={viewOrder.totalPrice}
        disabled={isValidating}
      />
      {refund.orderRefundPrice > 0 && (
        <Alert variant='warning'>
          <strong>Note:</strong> A custom refund amount has been entered. Item-level details,
          including <strong>discounts</strong>, <strong>tax</strong>, and{' '}
          <strong>shipping charges</strong>, will remain unchanged.
        </Alert>
      )}
    </>
  )
}

export default RefundAmount
